import { TranscriptSegment, TranscriptSegmentGroup } from '../../../domain';

export const reduceSegmentToSegmentGroups = (segments: TranscriptSegment[]) => {
  return segments.reduce(
    (segmentGroups: TranscriptSegmentGroup[], segment: TranscriptSegment) => {
      const {
        speaker: currentSpeaker = 'Unknown',
        start: currentStart,
        end: currentEnd,
      } = segment;

      if (!segmentGroups.length) {
        segmentGroups.push({
          speaker: currentSpeaker,
          segments: [segment],
          start: currentStart,
          end: currentEnd,
        });
        return segmentGroups;
      }

      const lastGroup = segmentGroups[segmentGroups.length - 1];
      const lastSegment = lastGroup.segments[lastGroup.segments.length - 1];
      if (
        lastGroup.speaker === currentSpeaker &&
        lastSegment.end > currentStart - 5 // timediff between segments
      ) {
        lastGroup.segments.push(segment);
        lastGroup.end = segment.end;
      } else {
        segmentGroups.push({
          speaker: currentSpeaker,
          segments: [segment],
          start: currentStart,
          end: currentEnd,
        });
      }
      return segmentGroups;
    },
    [],
  );
};
